module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.3.3 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/badge.html"
    }
  }, [_vm._v("Badge")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Use dot styles if no text is specified")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell.html"
    }
  }, [_vm._v("Cell")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support slot:title")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-radio.html"
    }
  }, [_vm._v("PopupRadio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support slot:popup-header")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] Set max-height:100% by default")]), _vm._v(" "), _c('li', [_vm._v("[feature] Support prop:max-height")]), _vm._v(" "), _c('li', [_vm._v("[fix] disable mask scrolling on mobile #1475 @xiaobinhong1")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/selector.html"
    }
  }, [_vm._v("Selector")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] set placeholder color. #1465")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4cbb0074", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-4cbb0074"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.3.3-102.vue
// module id = 2224
// module chunks = 307